import { cn } from '../../../lib/utils';
import type { ImportTarget } from '@discovr/types';
import { reviewStatusLabel, type ReviewRowStatus } from './reviewRowStatus';

// One tone for every status that blocks the import, so "this row stops the
// import" reads the same whatever the reason.
const BLOCKING_TONE = 'bg-destructive/10';
const NEUTRAL_TONE = 'bg-muted';

const STATUS_TONE: Record<ReviewRowStatus, string> = {
  'needs-fix': BLOCKING_TONE,
  duplicate: BLOCKING_TONE,
  'in-campaign': BLOCKING_TONE,
  'will-update': 'bg-accent',
  'keeping-current': NEUTRAL_TONE,
  'no-changes': NEUTRAL_TONE,
  ready: 'bg-success/10',
};

export function ReviewStatusPill({ status, target = 'pipeline' }: { status: ReviewRowStatus; target?: ImportTarget }) {
  // Normal text colour on every tint: tinted text on a tinted pill is hard to read.
  return (
    <span className={cn('inline-flex h-6 items-center whitespace-nowrap rounded-full px-2 text-caption-medium text-foreground', STATUS_TONE[status])}>
      {reviewStatusLabel(status, target)}
    </span>
  );
}
